module.exports = __webpack_public_path__ + "static/Banglore-e81702f88c647946f79ab17dcca9faed.png";